var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.detailsComponent,{tag:"component",staticClass:"gl-grow",attrs:{"item":_vm.item,"version-key":_vm.versionKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }